<template>
  <div class="landing-new__body">
    <section class="certified">
      <h2>{{ $t('home.network.heading') }}</h2>
      <p class="certified__description">{{ $t('home.network.description') }}</p>
      <div class="certified__airlines">
        <div
          v-for="airline in airlines"
          :key="airline.name"
          class="certified__airline"
          :title="airline.title"
        >
          <div class="al-logo">
            <img :src="airline.logo" :alt="airline.alt" loading="lazy" decoding="async" />
          </div>
          <p>{{ airline.name }}</p>
        </div>
        <div
          class="certified__airline certified__airline--badge"
          :title="$t('home.network.liveTitle')"
        >
          <div class="al-logo">
            <img
              src="../images/landing/network/live-40-airlines.svg"
              :alt="$t('home.network.liveAlt')"
              loading="lazy"
              decoding="async"
            />
          </div>
          <p>{{ $t('home.network.liveLabel') }}</p>
        </div>
        <div
          class="certified__airline certified__airline--badge"
          :title="$t('home.network.moreComingTitle')"
        >
          <div class="al-logo">
            <img
              src="../images/landing/network/more-airlines-coming.svg"
              :alt="$t('home.network.moreComingAlt')"
              loading="lazy"
              decoding="async"
            />
          </div>
          <p>{{ $t('home.network.moreComingLabel') }}</p>
        </div>
      </div>

      <div class="certified__iata">
        <img
          src="../images/landing/network/IATA.png"
          alt="IATA ARM System Provider"
          width="100"
          height="100"
          loading="lazy"
          decoding="async"
        />
        <h3>{{ $t('home.network.certHeading') }}</h3>
        <p>
          {{ $t('home.network.certDescriptionBefore') }}
          <a href="https://retailing.iata.org/armi/registry/drct/" target="_blank" rel="noopener">{{
            $t('home.network.certLinkLabel')
          }}</a>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import lufthansaLogo from '../images/landing/network/Lufthansa.svg';
import britishAirwaysLogo from '../images/landing/network/british-airways.svg';
import airFranceLogo from '../images/landing/network/air-france.svg';
import klmLogo from '../images/landing/network/KLM.svg';
import swissLogo from '../images/landing/network/SWISS.svg';
import emiratesLogo from '../images/landing/network/Emirates.svg';
import americanAirlinesLogo from '../images/landing/network/american-airlines.svg';
import iberiaLogo from '../images/landing/network/Iberia.svg';
import austrianAirlinesLogo from '../images/landing/network/austrian-airlines.svg';
import tapAirPortugalLogo from '../images/landing/network/tap-air-portugal.svg';
import lotPolishAirlinesLogo from '../images/landing/network/lot-polish-airlines.svg';
import unitedAirlinesLogo from '../images/landing/network/united-airlines.svg';
import flydubaiLogo from '../images/landing/network/flydubai.svg';

const AIRLINES = [
  { name: 'Lufthansa', title: 'Lufthansa', logo: lufthansaLogo, alt: 'Lufthansa' },
  {
    name: 'British Airways',
    title: 'British Airways',
    logo: britishAirwaysLogo,
    alt: 'British Airways',
  },
  { name: 'Air France', title: 'Air France', logo: airFranceLogo, alt: 'Air France' },
  { name: 'KLM', title: 'KLM', logo: klmLogo, alt: 'KLM' },
  { name: 'SWISS', title: 'SWISS', logo: swissLogo, alt: 'SWISS' },
  { name: 'Emirates', title: 'Emirates', logo: emiratesLogo, alt: 'Emirates' },
  {
    name: 'American Airlines',
    title: 'American Airlines',
    logo: americanAirlinesLogo,
    alt: 'American Airlines',
  },
  { name: 'Iberia', title: 'Iberia', logo: iberiaLogo, alt: 'Iberia' },
  {
    name: 'Austrian',
    title: 'Austrian Airlines',
    logo: austrianAirlinesLogo,
    alt: 'Austrian Airlines',
  },
  { name: 'TAP', title: 'TAP Air Portugal', logo: tapAirPortugalLogo, alt: 'TAP Air Portugal' },
  {
    name: 'LOT',
    title: 'LOT Polish Airlines',
    logo: lotPolishAirlinesLogo,
    alt: 'LOT Polish Airlines',
  },
  {
    name: 'United Airlines',
    title: 'United Airlines',
    logo: unitedAirlinesLogo,
    alt: 'United Airlines',
  },
  { name: 'flydubai', title: 'flydubai', logo: flydubaiLogo, alt: 'flydubai' },
];

export default {
  data() {
    return {
      airlines: AIRLINES,
    };
  },
};
</script>

<style lang="scss" scoped>
.certified {
  padding-bottom: 80px;
  padding-top: 80px;

  h2 {
    color: #1b2733;
    font-size: 31px;
    font-weight: 700;
    text-align: center;
  }
}

.certified__description {
  color: rgba(27, 39, 51, 0.9);
  font-size: 14px;
  line-height: 1.57;
  margin-top: 10px;
  opacity: 0.9;
  text-align: center;
}

.certified__airlines {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 20px;
  row-gap: 32px;
  width: 100%;
  max-width: 700px;
  margin: 44px auto 0;
}

.certified__airline {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  p {
    font-size: 11px;
    color: rgba(27, 39, 51, 0.45);
    font-weight: 500;
    text-align: center;
    margin: 0;
    opacity: 0;
    transition: opacity 0.18s;
  }

  &:hover p {
    opacity: 1;
  }
}

.al-logo {
  width: 100%;
  max-width: 90px;
  aspect-ratio: 1;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.certified__iata {
  display: flex;
  flex-direction: column;
  justify-content: center;

  img {
    display: block;
    margin: 60px auto 0;
  }

  h3 {
    color: #1b2733;
    font-size: 17px;
    font-weight: 700;
    margin-top: 20px;
    text-align: center;
  }

  p {
    color: rgba(27, 39, 51, 0.9);
    font-size: 14px;
    line-height: 1.57;
    margin-top: 8px;
    text-align: center;

    a {
      border-bottom: 1px solid rgba(42, 138, 234, 0.2);
      color: rgba(42, 138, 234, 0.85);

      &:hover {
        border-bottom-color: rgba(42, 138, 234, 0.4);
        color: #2a8aea;
      }
    }
  }
}

@media (min-width: 768px) {
  .certified__airlines {
    grid-template-columns: repeat(5, 90px);
    column-gap: 31px;
    justify-content: center;
  }
}

@media (max-width: 767px) {
  .certified {
    padding-bottom: 60px;
    padding-top: 60px;
  }
  .certified h2 {
    font-size: 27px;
  }

  .certified__airlines {
    grid-template-columns: repeat(3, 60px);
    column-gap: 43px;
    justify-content: center;
    row-gap: 20px;
    max-width: 360px;
  }

  .certified__airline p {
    opacity: 0;
  }
  .certified__airline:hover p {
    opacity: 1;
  }

  .al-logo {
    max-width: 60px;
  }
}
</style>
